
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem4Grid extends Serenity.EntityGrid<PsAdvPromoItem4Row, any> {
        protected getColumnsKey() { return PsAdvPromoItem4Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem4Dialog; }
        protected getIdProperty() { return PsAdvPromoItem4Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem4Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem4Row.localTextPrefix; }
        protected getService() { return PsAdvPromoItem4Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}